/**
 * Copyright (c) 2022 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
export var ColorThemeCategory = {
    Atom: 'Atom Property',
    Chain: 'Chain Property',
    Residue: 'Residue Property',
    Symmetry: 'Symmetry',
    Validation: 'Validation',
    Misc: 'Miscellaneous',
};
